import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '../../store/authStore'
import { useUIStore } from '../../store/uiStore'
import api from '../../services/api'

interface UsageInfo {
  tokens_used: number
  spend_usd: number
  limit_usd: number
  remaining_usd: number
  allowed: boolean
}

export default function Navbar() {
  const { user, logout } = useAuthStore()
  const { toggleSidebar } = useUIStore()

  const { data: usage } = useQuery({
    queryKey: ['myUsage'],
    queryFn: async () => (await api.get<UsageInfo>('/auth/me/usage')).data,
    refetchInterval: 60_000,
    enabled: !!user,
  })

  const usagePct = usage ? Math.min(100, (usage.spend_usd / usage.limit_usd) * 100) : 0
  const usageColor = !usage
    ? 'text-gray-500'
    : !usage.allowed
      ? 'text-red-600'
      : usagePct > 75
        ? 'text-amber-600'
        : 'text-green-600'

  return (
    <nav className="bg-white border-b border-gray-200 fixed w-full z-30 top-0">
      <div className="px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <button
            onClick={toggleSidebar}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>

          <div className="flex items-center gap-2">
            <span className="text-xl font-bold text-primary-600">LeadHunter</span>
          </div>
        </div>

        <div className="flex items-center gap-4">
          {usage && (
            <div
              className={`flex items-center gap-2 text-sm font-mono ${usageColor}`}
              title={`Tokens today: ${usage.tokens_used.toLocaleString()}\nLimit: $${usage.limit_usd.toFixed(2)}\nRemaining: $${usage.remaining_usd.toFixed(2)}`}
            >
              <span>${usage.spend_usd.toFixed(3)}</span>
              <span className="text-gray-300">/</span>
              <span className="text-gray-500">${usage.limit_usd.toFixed(2)}</span>
              {!usage.allowed && (
                <span className="px-1.5 py-0.5 bg-red-100 text-red-700 text-xs rounded">
                  Лимит
                </span>
              )}
            </div>
          )}

          <span className="text-sm text-gray-600">{user?.email}</span>

          <button
            onClick={logout}
            className="text-sm text-gray-600 hover:text-gray-900"
          >
            Sign out
          </button>
        </div>
      </div>
    </nav>
  )
}
